
  import { Component, Vue, Prop, PropSync } from 'vue-property-decorator';
  import { routePaths } from '@/router';
  import { DashboardCountStatus } from '@/models';
  import { mcDate, eventBus, mcEvents } from '@/utils';
  import { MealCountDtoViewModel } from '@/view-models';

  @Component
  export default class McMealCard extends Vue {
    @Prop() readonly mealTypeId!: string;
    @PropSync("model", { type: Object }) modelSync!: MealCountDtoViewModel;
    @PropSync("countStatus", { type: Object }) countStatusSync!: DashboardCountStatus;
    @Prop() readonly cardClass!: any;


    mounted() {
    }

    goToReceive() {
      const mc = this.modelSync.mealCounts;
      const sponsorId = this.modelSync.sponsorId;
      const date = mcDate.toShortDate(mc.mealServiceDate);
      const query = this.getRouteQueryParams(mc.siteId, sponsorId, mc.programId, date, this.mealTypeId.toUpperCase(), 'receive');
      this.$router.push({
        name: routePaths.serveMeals.name,
        params: query
      });
    }

    handleServeClick() {
      const mc = this.modelSync.mealCounts;
      const sponsorId = this.modelSync.sponsorId;
      const date = mcDate.toShortDate(mc.mealServiceDate);
      const query = this.getRouteQueryParams(mc.siteId, sponsorId, mc.programId, date, this.mealTypeId.toUpperCase(), 'serve');
      eventBus.$emit(mcEvents.serveClicked, query);
    }

    sendMealCounts() {
      eventBus.$emit(mcEvents.sendMealCounts, this.modelSync);
      this.handleServeClick();
    }

    getRouteQueryParams(siteId, sponsorId, programId, date, mealType, type) {
      return {
        siteId: siteId,
        sponsorId: sponsorId,
        programId: programId,
        date: date,
        mealType: mealType,
        type: type
      }
    }
  }
